var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "function-panel" }, [
    _c("label", { staticClass: "section-label" }, [_vm._v("变量")]),
    _c(
      "div",
      { staticClass: "function-categories" },
      _vm._l(_vm.categories, function (category) {
        return _c(
          "div",
          { key: category.label, staticClass: "category-item" },
          [
            _c(
              "div",
              {
                staticClass: "category-header",
                on: {
                  click: function ($event) {
                    return _vm.toggleCategory(category.label)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-arrow-right",
                  class: {
                    "rotate-90": _vm.expandedCategories.includes(
                      category.label
                    ),
                  },
                }),
                _vm._v(" " + _vm._s(category.label) + " "),
              ]
            ),
            _vm.expandedCategories.includes(category.label)
              ? _c(
                  "div",
                  { staticClass: "function-list" },
                  _vm._l(
                    category.children.filter(
                      (item) => item.dataType === 2 || item.dataType === 4
                    ),
                    function (func) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.searchQuery ||
                                _vm.isFunctionMatchSearch(func),
                              expression:
                                "!searchQuery || isFunctionMatchSearch(func)",
                            },
                          ],
                          key: func.label,
                          staticClass: "function-item",
                          on: {
                            click: function ($event) {
                              return _vm.handleFunctionClick(category, func)
                            },
                            mouseenter: function ($event) {
                              return _vm.handleFunctionMouseEnter(func)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(func.label) + " ")]
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }